import { render, staticRenderFns } from "./xhAllPrice.vue?vue&type=template&id=407544e4"
import script from "./xhAllPrice.vue?vue&type=script&lang=js"
export * from "./xhAllPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports